/**
 * Close a sentence that will have another sentence written after it (#2335).
 *
 * Some copy splices a message it does not own — a server error, a catalog
 * fallback — in front of its own sentences (`{{message}} Links are…`). Those
 * messages arrive with or without a full stop, so the join read
 * "…sign-in link Links are…". Text already ending in sentence punctuation is
 * returned as is; otherwise a full stop is added — the ideographic `。` after
 * CJK text, `.` after anything else.
 */
const TERMINAL = /[.!?。！？…]$/;
const CJK_END = /[\u3000-\u303f\u3400-\u4dbf\u4e00-\u9fff\uff00-\uffef]$/;

export function asSentence(text: string): string {
  const trimmed = text.trim();
  if (!trimmed || TERMINAL.test(trimmed)) return trimmed;
  return `${trimmed}${CJK_END.test(trimmed) ? '。' : '.'}`;
}
